import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faEye } from '@fortawesome/free-solid-svg-icons';
import { db } from './firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import './Dashboard.css';

function Dashboard() {
  const [stats, setStats] = useState({
    totalVisits: 0,
    totalQRCodes: 0,
  });

  useEffect(() => {
    // Listen to visits collection
    const unsubscribeVisits = onSnapshot(
      collection(db, 'visits'),
      (snapshot) => {
        setStats(prev => ({ ...prev, totalVisits: snapshot.size }));
      },
      (error) => {
        console.log('Error listening to visits:', error);
      }
    );

    // Listen to qrcodes collection
    const unsubscribeQRCodes = onSnapshot(
      collection(db, 'qrcodes'),
      (snapshot) => {
        setStats(prev => ({ ...prev, totalQRCodes: snapshot.size }));
      },
      (error) => {
        console.log('Error listening to qrcodes:', error);
      }
    );

    // Cleanup subscriptions
    return () => {
      unsubscribeVisits();
      unsubscribeQRCodes();
    };
  }, []);

  return (
    <div className="dashboard-compact">
      <div className="stats-compact">
        <div className="stat-item-compact">
          <FontAwesomeIcon icon={faEye} className="stat-icon-compact" />
          <span className="stat-number">{stats.totalVisits.toLocaleString()}</span>
          <span className="stat-label-compact">ผู้เข้าชม</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item-compact">
          <FontAwesomeIcon icon={faQrcode} className="stat-icon-compact" />
          <span className="stat-number">{stats.totalQRCodes.toLocaleString()}</span>
          <span className="stat-label-compact">QR Code ที่สร้าง</span>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
